import React from 'react'
import { links } from 'common/helpers'

import Text from 'components/_new/typography/Text/Text'
import Link from 'components/_new/typography/Link/Link'

import messages from './messages'


const LoginButton = () => (
  <Link
    href={links.login}
    color="brand"
    withUnderline={false}
  >
    <Text size="18-24" semibold message={messages.button} />
  </Link>
)


export default LoginButton
